// extracted by mini-css-extract-plugin
export var buttonContent = "_3e-0";
export var centered = "_3e-1";
export var centeredFlex = "_3e-2";
export var errorText = "_3e-3";
export var icon = "_3e-4";
export var iconButtonContent = "_3e-5";
export var monospace = "_3e-6";
export var padded = "_3e-7";